module.exports = __webpack_public_path__ + "static/SharePointReactLogo-3dac21502e918a54b02da34e34f9df8d.svg";